import { Control, useForm } from 'react-hook-form';

import { AModal } from 'components/shared/AModal';
import Button from 'components/shared/Button';
import { HookCheckbox } from 'components/shared/HookFormComponents';
import Text from 'components/shared/Typography/Text';
import { useModalClose } from 'hooks/useModalClose';

import cs from '../index.module.css';
// @ts-expect-error // TOFIX: Webm is not recognized by TS
import webm from './content-missing.webm';

export function ContentMissingWarningModal({
  onClose,
  onSave,
}: {
  onClose: () => void;
  onSave: (...args: any) => Promise<{ isIgnoreForProposal: boolean }>;
}) {
  const { control, getValues } = useForm({ defaultValues: { isIgnoreForProposal: false } });
  // TODO: rework control props for adapters & delete it
  const depricatedControl = control as Control<any>;
  useModalClose();

  const handleSave = async () => {
    await onSave({ ...getValues() });
    onClose();
  };

  return (
    <AModal
      isOpen
      size="xs"
      onClose={onClose}
      header="Heads Up!"
      contentClassName={cs.modalContent}
      footer={
        <>
          <Button type="default" size="medium" onClick={handleSave}>
            Ignore & Continue
          </Button>
          <Button size="medium" onClick={onClose}>
            Add Content
          </Button>
        </>
      }
    >
      <form className={cs.description}>
        <Text type="accent" size="default">
          It seems you have not @mentioned any pages from your Content Library.
        </Text>
        <br />
        <br />
        <Text type="accent" size="default">
          If this is the case, there will not be any content in your itinerary.
        </Text>
        <video className={cs.hintGif} controls={false} autoPlay loop>
          <source src={webm} type="video/webm" />
        </video>

        <HookCheckbox control={depricatedControl} name="isIgnoreForProposal">
          Don’t show this again for this itinerary
        </HookCheckbox>
      </form>
    </AModal>
  );
}
